const EXPLICIT_LOGOUT_KEY = 'blms-explicit-logout';

function canUseStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

export function markExplicitLogout(): void {
  if (!canUseStorage()) {
    return;
  }

  try {
    window.localStorage.setItem(EXPLICIT_LOGOUT_KEY, '1');
  } catch {
    // Ignore storage failures in locked-down browsers.
  }
}

export function clearExplicitLogout(): void {
  if (!canUseStorage()) {
    return;
  }

  try {
    window.localStorage.removeItem(EXPLICIT_LOGOUT_KEY);
  } catch {
    // Ignore storage failures in locked-down browsers.
  }
}

export function hasExplicitLogout(): boolean {
  if (!canUseStorage()) {
    return false;
  }

  try {
    return window.localStorage.getItem(EXPLICIT_LOGOUT_KEY) === '1';
  } catch {
    return false;
  }
}
